import React from "react";
import { Workflow } from "lucide-react";
import { FlowchartViewer } from "./FlowchartViewer";

const PAGES = [
  ["0-overview", "Overview"],
  ["1-setup", "A · Set up"],
  ["2-recording", "B · Record defects"],
  ["3-walkthrough", "C · Client walkthrough"],
  ["4-contractor", "D · Fix & close out"],
  ["5-signoff", "E · Client sign-off"],
];

export const DefectsFlowchart = () => (
  <FlowchartViewer id="defects-flowchart" icon={Workflow} title="Process Flowchart — Defects & Client Walkthrough"
    blurb="Step-by-step training guide for new site managers. Pick a stage, or download the printable PDF."
    pdf="/docs/SitePro_Defects_Process_Flowchart.pdf" pages={PAGES} />
);
